<ng-container *ngFor="let item of menuItems; trackBy: trackByItem">
	<mat-divider></mat-divider>
	<a
		*ngIf="!item.commandName; else commandMenuItem"
		mat-menu-item
		[obgRouteLink]="{ route: item.route, url: item.link?.url }"
		obgRouteLinkActive
		test-id="my-account-button"
		data-test-id="my-account-button"
		[target]="item.link?.target"
		(click)="selectedItem.emit(item.key)"
	>
		<span [class]="item.iconTag"></span><span>{{ item.title }}</span>
	</a>
	<ng-template #commandMenuItem>
		<button
			mat-menu-item
			[obgCommandDispatcher]="item.commandName"
			[attr.test-id]="item.commandName + '-button'"
			[attr.data-test-id]="item.commandName + '-button'"
			(click)="selectedItem.emit(item.key)"
		>
			<span [class]="item.iconTag"></span><span>{{ item.title }}</span>
		</button>
	</ng-template>
</ng-container>
